import React, {Component} from "react";
import {connect} from "react-redux";
import { organization } from "../../actions";
import API from '../API';
import { Map, ScaleControl, Marker, TileLayer } from 'react-leaflet'
import {transform} from 'ol/proj';

class Organization extends Component {

  constructor(props) {
    super(props);

    let center = this.props.loginUser.organization.location.split(',')
    this.state = {
      zoom: 15,
      ori_center: center,
      center: center,
    }

    this.handleClickOnMap = this.handleClickOnMap.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }


  handleClickOnMap(e){
      var coordinate = e.latlng;
      this.setState({
        center: [coordinate.lat, coordinate.lng]
      });
  }
  

  handleSubmit(){
    this.setState({ loading: true });
    let center = this.state.center[0] + ',' + this.state.center[1];
    this.props.updateLocation(this.props.loginUser.organization.id, center, this.props.history);
  }



  componentDidMount() {
  }

  render() {
    return (
      <div>
        <p>{'拠点の位置を選択してください。'}</p>
        <hr className='settings-hr' />

        <div className='map-view'>
          <Map ref='map' center={this.state.ori_center} zoom={this.state.zoom} doubleClickZoom={true} attributionControl={false} style={{ height: '80vh' }} onclick={this.handleClickOnMap} maxZoom={22} >
            {/* ★変更：国土地理院 → Esri World Imagery (ArcGIS) TileLayer */}
            <TileLayer
              attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
              url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
              maxZoom={22}
              maxNativeZoom={19}
            />
            <ScaleControl className="" position="bottomleft" imperial={false} />
              handleClickOnMap={this.handleClickOnMap}
            <Marker position={this.state.center} />
          </Map>
        </div>

        <input
          value={this.state.center[0]}
          readOnly={true}
        />
        <input
          value={this.state.center[1]}
          readOnly={true}
        />

        <button className='settings-regist-btn' onClick={this.handleSubmit} >更新</button>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loginUser: state.auth.user,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    updateLocation: (org_id, org_location, history) => dispatch(organization.updateLocation(org_id, org_location, history)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Organization);
